import React from "react";
import { Field, ErrorMessage } from "formik";
import InputOption from "../InputOption/InputOption";

const ContactComponent = ({ label = 'Pelanggan', hintInput = 'Pilih Pelanggan',  contact, onChange, defaultValue }) => {
  return (
    <>
      <div className="p-3">
        <label htmlFor="customer" className="mb-1 text-sm font-semibold">
          {label}
        </label>
        <InputOption
          label={hintInput}
          data={contact}
          placeholder="Ketik disini"
          onChange={onChange}
          defaultValue={defaultValue} />
        <ErrorMessage
          name="customer"
          component="p"
          className="text-red-500 text-xs mt-1"
        />
      </div>
      <div className="p-3">
        <label htmlFor="email" className="mb-1 text-sm font-semibold">
          Email
        </label>
        <Field
          name="email"
          className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
        />
        <ErrorMessage
          name="email"
          component="p"
          className="text-red-500 text-xs mt-1"
        />
      </div>
    </>
  );
};

export default ContactComponent;
